import * as React from 'react';
// import { Checkbox } from 'office-ui-fabric-react/lib/Checkbox';
import { Checkbox, ICheckboxStyles } from '@fluentui/react';
import { ITermProps, ITermState } from './ITaxonomyPicker';
import './TaxonomyPicker.css';
import TermActionsControl from './termActions/TermActionsControl';
import { UpdateAction, UpdateType } from './termActions';


/**
 * Term component
 * Renders a selectable term
 */
export default class Term extends React.Component<ITermProps, ITermState> {

  constructor(props: ITermProps) {
    super(props);

    // Check if current term is selected
    let active = this.props.activeNodes.filter(item => item.key === this.props.term.Id);

    this.state = {
      selected: active.length > 0,
      termLabel: this.props.term.Name,
      hidden: false,
      disabled: false
    };

    this._handleChange = this._handleChange.bind(this);
  }

  /**
   * Handle the checkbox change trigger
   */
  private _handleChange(ev: React.FormEvent<HTMLElement>, isChecked: boolean) {
    this.setState({
      selected: isChecked
    });
    this.props.changedCallback(this.props.term, isChecked);
  }

  /**
   * Lifecycle event hook when component retrieves new properties
   * @param nextProps
   * @param nextContext
   */
  public componentWillReceiveProps?(nextProps: ITermProps, nextContext: any): void {
    // If multi-selection is turned off, only a single term can be selected
    //if (!this.props.multiSelection) {
    let active = nextProps.activeNodes.filter(item => item.key === this.props.term.Id);
    this.setState({
      selected: active.length > 0,
      termLabel: this.state.termLabel
    });
    //}
  }

  /**
   * Get the right class name for the term
   */
  private getClassName() {
    if (this.props.term.IsDeprecated) {
      return 'termDisable';
    }

    if (!this.props.term.IsAvailableForTagging) {
      return 'termNoTagging';
    }

    return 'termEnabled';
  }

  private termActionCallback = (updateAction: UpdateAction | null): void => {
    if (!updateAction) {
      return;
    }

    if (updateAction.updateActionType === UpdateType.updateTermLabel) {
      this.setState({
        termLabel: updateAction.value as string
      });
    } else if (updateAction.updateActionType === UpdateType.hideTerm) {
      this.setState({
        hidden: updateAction.value as boolean
      });
    } else if (updateAction.updateActionType === UpdateType.disableTerm) {
      this.setState({
        disabled: updateAction.value as boolean
      });
    } else if (updateAction.updateActionType === UpdateType.selectTerm) {
      // Only select the term when not disabled or hidden
      if (!this.state.disabled && !this.state.hidden) {
        this._handleChange(null, updateAction.value as boolean);
      }
    } else {
      this.props.updateTaxonomyTree();
    }
  }

  /**
   * Default React render
   */
  public render(): JSX.Element {
    const styleProps: React.CSSProperties = {
      marginLeft: `${(this.props.term.PathDepth * 30)}px`
    };
    const checkBoxStyle: ICheckboxStyles = {
      root: {
        display: "inline-flex"
      }
    };

    if (this.state.hidden) {
      return null;
    }

    return (
      <div>
        <div className={`listItem term`} style={styleProps}>
          <div>
            <Checkbox
              checked={this.state.selected}
              styles={checkBoxStyle}
              disabled={this.props.term.IsDeprecated || !this.props.term.IsAvailableForTagging || this.props.disabled || this.state.disabled}
              className={this.getClassName()}
              label={this.state.termLabel}
              onChange={this._handleChange} />
          </div>
          {
            this.props.termActions &&
            <TermActionsControl term={this.props.term}
              termActions={this.props.termActions}
              termActionCallback={this.termActionCallback}
              spTermService={this.props.spTermService} />
          }
        </div>
      </div>

    );
  }
}
